import { LinearProgress, Tooltip, Typography } from "@mui/material";
import { get } from "lodash";

import { Table, TableBody, TableCell, TableHead, TableRow } from "ui";

import { assessConfigurationHasValues, getFactorScoringInputConfig, ScoringInputConfig } from "fond/cityPlanner/assessConfigurationHelper";
import { AssessConfiguration, ScoreFactor } from "fond/types";

type ScoringValuesProps = {
  config?: AssessConfiguration;
  scoringInputConfigs: ScoringInputConfig[];
  factor: ScoreFactor;
  title: string;
};

export const ScoringValues: React.FC<ScoringValuesProps> = ({ config, scoringInputConfigs, factor, title }: ScoringValuesProps) => {
  if (!assessConfigurationHasValues(config, scoringInputConfigs, factor)) {
    return null;
  }

  const getCriteriaRow = ({ id, path, title: criteriaTitle, description }: ScoringInputConfig) => {
    const configValueForId = get(config, path ?? id);
    if (configValueForId == null) {
      return null;
    }

    return (
      <TableRow key={id}>
        <TableCell width={125}>
          <Tooltip title={description} placement="right-start">
            <span>{criteriaTitle}</span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <LinearProgress variant="determinate" value={configValueForId * 100} />
        </TableCell>
      </TableRow>
    );
  };
  const rows = getFactorScoringInputConfig(factor, scoringInputConfigs).map(getCriteriaRow);

  return (
    <>
      <Typography component="p" variant="h7" mb={1} mt={2}>
        {title}
      </Typography>
      <Table variant="ag-grid-compact">
        <TableHead>
          <TableRow>
            <TableCell>Criteria</TableCell>
            <TableCell width={100}>Importance</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </Table>
    </>
  );
};
